// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__27EUI","savePackageButton":"ClientWallet_savePackageButton__6sMpi"};